module.exports = __webpack_public_path__ + "static/media/sub.ee2e3737.svg";